<template>
    <v-container>
        <v-form ref="fm_personal_info" autocomplete="off">
            <v-card outlined tile elevation="2">
                <v-card-title class="font-weight-light mb-2">Legal Name</v-card-title>
                <v-card-text>
                    <v-row class="justify-space-around">
                        <v-col cols="12" sm="2" class="py-0 mt-2">
                            <v-select
                                ref="oma_prefix"
                                v-model="oma_prefix"
                                :items="prefix_options"
                                :loading="prefix_options.length == 0"
                                item-text="prf_code"
                                item-value="prf_code"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                label="Prefix"
                                :rules="rules.oma_prefix"
                                clearable
                                autocomplete="off"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0 mt-2">
                            <v-text-field
                                ref="oma_first_name"
                                v-model="oma_first_name"
                                label="First Name"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                :rules="rules.oma_first_name"
                                autocomplete="off"
                            >
                                <template #label>
                                    First Name<span class="required red--text"> *</span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1" class="py-0 mt-2">
                            <v-text-field
                                ref="oma_middle_name"
                                v-model="oma_middle_name"
                                label="M.I."
                                :dense="$vuetify.breakpoint.mdAndUp"
                                maxlength="1"
                                :rules="rules.oma_middle_name"
                                autocomplete="off"
                                validate-on-blur
                                
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0 mt-2">
                            <v-text-field
                                ref="oma_last_name"
                                v-model="oma_last_name"
                                label="Last Name"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                :rules="rules.oma_last_name"
                                autocomplete="off"
                                
                            >
                                <template #label>
                                Last Name<span class="required red--text"> *</span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" class="py-0 mt-2">
                            <v-select
                                    ref="oma_suffix"
                                    v-model="oma_suffix"
                                    :loading="suffix_options.length == 0"
                                    :items="suffix_options"
                                    item-text="sfx_code"
                                    item-value="sfx_code"
                                    :dense="$vuetify.breakpoint.mdAndUp"
                                    label="Suffix"
                                    :rules="rules.oma_suffix"
                                    autocomplete="off"
                                    clearable
                                ></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card outlined tile elevation="2" class="mt-2">
                <v-card-title class="font-weight-light mb-2">Contact Information</v-card-title>
                <v-card-text>
                    <v-row class="justify-around">
                        <v-col cols="12" class="py-0 mt-2">
                            <v-text-field
                                ref="oma_street_address1"
                                v-model="oma_street_address1"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                label="Street Address Line 1"
                                required
                                :rules="rules.oma_street_address1"
                                @change="addressOverridden=false;"
                                autocomplete="off"
                            >
                                <template #label>
                                    Street Address Line 1<span class="required red--text"> *</span>
                                </template>
                            </v-text-field>
                        </v-col>                
                    </v-row>
                    <v-row class="justify-around">
                        <v-col cols="12" class="py-0 mt-2">
                            <v-text-field
                                ref="oma_street_address2"
                                v-model="oma_street_address2"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                label="Street Address Line 2"
                                :rules="rules.oma_street_address2"
                                @change="addressOverridden=false;"
                                autocomplete="off"
                            >                        
                            </v-text-field>
                        </v-col>                
                    </v-row>
                    <v-row class="justify-around">
                        <v-col cols="12" md="4" class="py-0 mt-2">
                            <v-text-field
                                ref="oma_city"
                                v-model="oma_city"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                label="City"
                                :rules="rules.oma_city"
                                @change="addressOverridden=false;"
                                autocomplete="off"
                            >
                                <template #label>
                                    City<span class="required red--text"> *</span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" md="3" class="py-0 mt-2">
                            <v-autocomplete
                                ref="oma_state"
                                v-model="oma_state"
                                :items="state_options"
                                item-text="val"
                                item-value="abbr"
                                :loading="state_options.length == 0"
                                :rules="rules.oma_state"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                @change="addressOverridden=false;"
                                autocomplete="off"
                                label="State"
                            >
                                <template #label>
                                    State<span class="required red--text"> *</span>
                                </template>
                            </v-autocomplete>
                        </v-col>                
                        <v-col cols="6" md="2" class="py-0 mt-2">
                            <v-text-field
                                ref="oma_zip"
                                v-model="oma_zip"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                label="Zip Code"
                                :rules="rules.oma_zip"
                                @change="addressOverridden=false;"
                                autocomplete="off"
                            >
                                <template #label>
                                    Zip Code<span class="required red--text"> *</span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" class="py-0 mt-2">
                            <v-autocomplete
                                ref="oma_county"
                                v-model="oma_county"
                                :items="county_options"
                                item-text="county"
                                item-value="county"
                                :disabled="county_options.length == 0"
                                :rules="rules.oma_county"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                autocomplete="off"
                                label="County"
                            >
                                <template #label>
                                    County<span class="required red--text"> *</span>
                                </template>
                            </v-autocomplete>
                        </v-col> 
                    </v-row>
                    
                    <v-row class="justify-around">
                        <v-col cols="12" sm="6" class="py-0 mt-2">
                            <v-text-field
                                ref="oma_home_email"
                                v-model="oma_home_email"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                label="Home Email Address"
                                :rules="rules.oma_home_email"
                                validate-on-blur
                                inputmode="email"
                                autocomplete="off"
                            >
                                <template #label>
                                    Home Email Address<span class="required red--text"> *</span>
                                </template>
                            </v-text-field>
                        </v-col>                
                        <v-col cols="12" sm="6" class="py-0 mt-2">
                            <v-text-field
                                ref="oma_confirm_home_email"
                                v-model="oma_confirm_home_email"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                label="Confirm Home Email Address"
                                :rules="[rules__oma_confirm_home_email]"
                                inputmode="email"
                                validate-on-blur
                                autocomplete="off"
                            >
                                <template #label>
                                    Confirm Home Email Address<span class="required red--text"> *</span>
                                </template>
                            </v-text-field>
                        </v-col>                
                    </v-row>
                    <v-row class="justify-around align-end">
                        <v-col cols="12" sm="7" class="py-0 mt-2">
                            <v-text-field
                                ref="oma_primary_phone"
                                v-mask="masks.phone"
                                type="tel"
                                v-model="oma_primary_phone"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                label="Primary Phone Number"
                                :rules="rules.oma_primary_phone"
                                validate-on-blur
                                autocomplete="off"
                            >
                                <template #label>
                                    Primary Phone Number
                                </template>
                            </v-text-field>
                        </v-col>                
                        <v-col cols="12" sm="5" class="py-0 mt-2">
                        <p class="mb-0">Primary Phone Type:<span v-show="oma_primary_phone != null && oma_primary_phone.length > 0" class="required red--text"> *</span></p>
                        <v-radio-group
                            ref="oma_pri_phone_type"                         
                            v-model="oma_pri_phone_type"
                            required
                            row
                            :dense="$vuetify.breakpoint.mdAndUp"
                            class="mt-0"
                            :rules="[ rules__oma_pri_phone_type ]"                       
                            >         
                                <v-radio
                                    label="Cell Phone"
                                    value="Cell"
                                ></v-radio>
                                <v-radio
                                    label="Home Phone"
                                    value="Home"
                                ></v-radio>
                            </v-radio-group>
                        </v-col>                
                    </v-row>
                    <v-row class="justify-around align-end">
                        <v-col cols="12" sm="7" class="py-0 mt-2">
                            <v-text-field
                                ref="oma_secondary_phone"
                                v-model="oma_secondary_phone"
                                v-mask="masks.phone"
                                type="tel"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                label="Secondary Phone Number"
                                :rules="rules.oma_secondary_phone"
                                validate-on-blur
                            ></v-text-field>
                        </v-col>                
                        <v-col cols="12" sm="5" class="py-0 mt-2">
                            <p class="mb-0">Secondary Phone Type:<span v-show="oma_secondary_phone != null && oma_secondary_phone.length > 0" class="required red--text"> *</span></p>
                            <v-radio-group
                                ref="oma_sec_phone_type"
                                v-model="oma_sec_phone_type"
                                row
                                :dense="$vuetify.breakpoint.mdAndUp"
                                class="mt-0"
                                :rules="[ rules__oma_sec_phone_type ]"                                                       
                                >
                                <v-radio
                                    label="Cell Phone"
                                    value="Cell"
                                ></v-radio>
                                <v-radio
                                    label="Home Phone"
                                    value="Home"
                                ></v-radio>
                            </v-radio-group>
                        </v-col>                
                    </v-row>
                    <v-row v-if="enteredCellNumber">
                        <v-col cols="12">
                            <p class="font-weight-regular" style="font-size:0.75em;">By providing my phone number, I understand that the NEA and its affiliates including the MEA, the Local association, NEA Member Benefits, and NEA 360 may use automated calling techniques and/or text message me on my cellular phone on a periodic basis. The NEA, the MEA and the Local association will not charge for text message alerts. Carrier message and data rates may apply to such alerts. Text STOP to 69866 to stop receiving messages from MEA; 84693 to stop receiving messages form NEA. Text HELP for more information.</p>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card outlined tile elevation="2" class="mt-2">
                <v-card-title class="font-weight-light mb-2">Other Information</v-card-title>
                <v-card-text>
                    <v-row class="flex-wrap justify-around">
                        <v-col cols="12" sm="2" class="py-0 mt-2 d-flex flex-row">
                            <v-text-field
                                ref="oma_ssn"
                                v-model="oma_ssn"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                label="SSN Last 4"
                                type="tel"
                                hide-spin-buttons
                                :class="{'hide-ssn': !showSsn}"
                                required
                                maxlength="4"
                                validate-on-blur
                                :rules="rules.oma_ssn"
                            >
                                <template #label>
                                    SSN Last 4<span class="required red--text"> *</span>
                                </template>
                            </v-text-field>
                            <v-btn @click="showSsn = !showSsn" icon>
                              <font-awesome-icon :icon="showSsn ? 'eye-slash' :'eye'" />
                            </v-btn>
                        </v-col>  
                        <v-col cols="12" sm="3" class="py-0 mt-2">
                            <v-text-field
                                ref="oma_dob"
                                v-model="oma_dob"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                label="Birthday"
                                required
                                :rules="[rules__oma_dob]"
                                hint="MM/DD/YYYY"
                                validate-on-blur
                                autocomplete="off"
                            >
                                <template #label>
                                    Birthday<span class="required red--text"> *</span>
                                </template>   
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0 mt-2">
                            <v-text-field
                                ref="oma_preferred_name"
                                v-model="oma_preferred_name"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                label="Nickname"
                                :rules="rules.oma_preferred_name"
                                autocomplete="off"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0 mt-2">
                            <v-text-field
                                ref="oma_previous_last_name"
                                v-model="oma_previous_last_name"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                label="Previous Last Name"
                                :rules="rules.oma_previous_last_name"
                                autocomplete="off"
                            ></v-text-field>
                        </v-col>              
                        <v-col cols="12" sm="3" class="py-0 mt-2">
                            <v-select
                                ref="oma_gender"
                                v-model="oma_gender"
                                :items="gender_options"
                                item-text="dem_name"
                                item-value="dem_value"
                                :loading="gender_options.length == 0"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                label="Gender"
                                :rules="rules.oma_gender"
                            >
                                <template #label>
                                    Gender
                                </template> 
                            </v-select>
                        </v-col> 
                        <v-col cols="12" sm="5" class="py-0 mt-2">
                            <v-select
                                ref="oma_ethnicity"
                                v-model="oma_ethnicity"
                                :items="ethnicity_options"
                                item-text="dem_name"
                                item-value="dem_value"
                                :loading="ethnicity_options.length == 0"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                label="Race/Ethnicity"
                                :rules="rules.oma_ethnicity"
                            >
                                <template #label>
                                    Race/Ethnicity
                                </template> 
                            </v-select>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0 mt-2">
                            <v-select
                                ref="oma_pronouns"
                                v-model="oma_pronouns"
                                :items="pronoun_options"
                                item-text="dem_name"
                                item-value="dem_value"
                                :loading="pronoun_options.length == 0"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                label="Preferred Pronouns"
                                :rules="rules.oma_pronouns"
                                clearable
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="2" class="py-0 mt-2 align-self-end">
                            <v-text-field
                                ref="oma_pic_num"
                                v-model="oma_pic_num"
                                :dense="$vuetify.breakpoint.mdAndUp"
                                label="PIC Number (if applicable)"
                                :rules="rules.oma_pic_num"
                                autocomplete="off"
                                type="number"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="5" class="py-0 mt-2">
                            <div>Have you been an MEA member before?<span class="required red--text"> *</span></div>
                            <v-radio-group
                                ref="oma_pre_memb"
                                v-model="oma_pre_memb"
                                row
                                dense
                                :rules="rules.oma_pre_memb"
                            >                                
                                <v-radio                            
                                    label="Yes"
                                    value="Yes"
                                ></v-radio>
                                <v-radio
                                    label="No"
                                    value="No"
                                ></v-radio>                                
                            </v-radio-group>
                        </v-col>                        
                    </v-row>
                </v-card-text>
            </v-card>
            <v-row>
                <v-col cols="12" class="mt-3 d-flex justify-end">
                    <v-btn
                    color="rgb(0 48 87)"
                    tile
                    @click="validate_and_continue"
                    dark
                    >
                    Continue to Step 2
                    </v-btn>
                </v-col>
            </v-row>            
        </v-form>
        <errors-on-form-dialog :showDialog="showErrorsOnPage" @close-dialog="showErrorsOnPage=false;"></errors-on-form-dialog>
        <error-dialog @close-dialog="showError=false;" :showDialog="showError" :errorObject="errorObj" :errorIsFatal="errorIsFatal"></error-dialog>
        <saving-progress-dialog :showDialog="showSavingProgress"></saving-progress-dialog>
        <invalid-address-dialog @close-dialog="showInvalidAddressDialog=false;" @override-address="override_invalid_address" :addressObject="invalidAddressObject" :showDialog="showInvalidAddressDialog"></invalid-address-dialog>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import ErrorsOnFormDialog from './DialogComponents/ErrorsOnFormDialog.vue';
  import {format} from 'date-fns'
  import ErrorDialog from './DialogComponents/ErrorDialog.vue';
  import SavingProgressDialog from './DialogComponents/SavingProgressDialog.vue';
  import InvalidAddressDialog from './DialogComponents/InvalidAddressDialog.vue';
  import commonMixins from '@/mixins/commonMixins';

  export default {
    components: { ErrorsOnFormDialog, ErrorDialog, SavingProgressDialog, InvalidAddressDialog},
    name: 'PersonalInfo',
    mixins:[commonMixins],
    props:{
    },
    data:() => ({
        showErrorsOnPage: false,
        showError: false,        
        errorObj: {},
        showSsn: false,
        errorIsFatal: false,
        showSavingProgress: false,
        showInvalidAddressDialog:false,
        invalidAddressObject: {},  
        addressOverridden:false,
        prefix_options: [],              
        suffix_options: [],        
        gender_options: [],        
        ethnicity_options: [],        
        pronoun_options: [],
        oma_confirm_home_email: null,
        oma_ssn: null,
        rules: {
            oma_prefix:[
                v => {
                    if(v) return /^[A-z]+$/.test(v) || 'Prefix is invalid';
                    else return true;
                }
            ],
            oma_first_name:[
                v => !!v || 'First Name is required',
                v => /^[\w'\s.-]+$/.test(v) || 'First Name is invalid'
            ],
            oma_middle_name:[
                v => {
                    if(v) return /^[A-z]?$/.test(v) || 'invalid';
                    else return true;
                }
            ],
            oma_last_name:[
                v => !!v || 'Last Name is required',
                v => /^[\w'\s.-]+$/.test(v) || 'Last Name is invalid'],
            oma_suffix:[
                v => {
                    if(v) return /^[A-z]+$/.test(v) || 'Suffix is invalid';
                    else return true;
                }
            ],
            oma_street_address1:[
                v => !!v || 'Street Line 1 is required',
                v => /^[\w\s.,'/#:\\-]+$/.test(v) || 'Street Line 1 is invalid'
            ],
            oma_street_address2:[
                v => {
                    if(v) return /^[\w\s.,'/#:\\-]+$/.test(v) || 'Street Line 2 is invalid';
                    else return true;
                }
            ],
            oma_state:[
                v => !!v || 'State is required',
                v => /^[A-z]{2}$/.test(v) || 'State is invalid'
            ],
            oma_city:[
                v => !!v || 'City is required',
                v => /^[a-zA-Z ]+$/.test(v) || 'City is invalid'
            ],
            oma_county:[
                v => !!v || 'County is required',
                v => /^[a-zA-Z.']+(?:[\s-][a-zA-Z.']+)*$/.test(v) || 'County is invalid'
            ],
            oma_zip: [
                v => !!v || 'Zip Code is required',
                v => /^((?:[0-9]{5}(?:-[0-9]{4})?)|(?:[ABCEGHJKLMNPRSTVXY]{1}[0-9]{1}[A-Z]{1} *[0-9]{1}[A-Z]{1}[0-9]{1}))$/.test(v) || 'Zip Code is invalid'
            ],
            oma_primary_phone:[
                v => {
                    if(v) return /^\(\d{3}\) \d{3}-\d{4}$/.test(v) || 'Primary Phone is invalid';
                    else return true;
                }
            ],            
            oma_secondary_phone:[
                v => {
                    if(v) return /^\(\d{3}\) \d{3}-\d{4}$/.test(v) || 'Secondary Phone is invalid';
                    else return true;
                }
            ],            
            oma_home_email:[
                v => !!v || 'Home Email is required',
                v => /^\S+@\S+\.\S+$/.test(v) || 'Home Email is invalid'
            ],            
            oma_ssn:[
                v => !!v || 'Last 4 required',
                v => /(?!0{4})\d{4}/.test(v) || 'SSN is invalid'
            ],
            oma_preferred_name:[
                v => {
                    if(v) return /^[\w'\s.-]+$/.test(v) || 'Preferred Name is invalid';
                    else return true;
                }
            ],
            oma_previous_last_name:[
                v => {
                    if(v) return /^[\w'\s.-]+$/.test(v) || 'Previous Last Name is invalid';
                    else return true;
                }
            ],            
            oma_gender:[
                v => {
                    if(v) return /^[a-zA-Z ]+$/.test(v) || 'Gender is invalid';
                    else return true;
                }
            ],
            oma_ethnicity:[
                v =>{
                    if(v) return /^[a-zA-Z ,/\-/()]+$/.test(v) || 'Race/Ethnicity is invalid';
                    else return true;
                }
            ],
            oma_pronouns:[
                v => {
                    if(v) return /.+/.test(v) || 'Pronouns are invalid';
                    else return true;
                }
            ],
            oma_pre_memb:[
                v => !!v || 'Previous Member Required',
                v => /^Yes|No$/.test(v) || 'Previous Member is invalid'
            ],
            oma_pic_num:[
                v => {
                    if(v) return /\d+/.test(v) || 'PIC Number is invalid';
                    else return true;
                }
            ]  
        },
        masks:{
            phone: '(###) ###-####',
            date: '##/##/####'
        }
    }),
    computed:{
        state_options(){
            return this.$store.state.stateOptions;
        },
        county_options(){
            return this.$store.getters.getCountyOptions;
        },
        enteredCellNumber(){
            return /^cell$/i.test(this.oma_pri_phone_type) || /^cell$/i.test(this.oma_sec_phone_type);
        },  
        oma_first_name: {
            get(){
                return this.$store.state.oma_first_name;
            },
            set(value){
                this.$store.state.oma_first_name = value;
            }
        },
        oma_prefix:{
            get(){
                return this.$store.state.oma_prefix;
            },
            set(value){
                this.$store.state.oma_prefix = value;
            }
        },        
        oma_last_name:{
            get(){
                return this.$store.state.oma_last_name;
            },
            set(value){
                this.$store.state.oma_last_name = value;
            }
        },
        oma_suffix:{
            get(){
                return this.$store.state.oma_suffix;
            },
            set(value){
                this.$store.state.oma_suffix = value;
            }
        },
        oma_street_address1: {
            get(){
                return this.$store.state.oma_street_address1;
            },
            set(value){
                this.$store.state.oma_street_address1 = value;
            }
        },
        oma_street_address2: {
            get(){
                return this.$store.state.oma_street_address2;
            },
            set(value){
                this.$store.state.oma_street_address2 = value;
            }
        },
        oma_state: {
            get(){                
                return this.$store.state.oma_state;
            },
            set(value){
                this.$store.state.oma_state = value;
            }
        },
        oma_middle_name: {
            get(){
                return this.$store.state.oma_middle_name;
            },
            set(value){
                this.$store.state.oma_middle_name = value;
            }
        },
        oma_city: {
            get(){
                return this.$store.state.oma_city;
            },
            set(value){
                this.$store.state.oma_city = value;
            }
        },
        oma_zip: {
            get(){
                return this.$store.state.oma_zip;
            },
            set(value){
                this.$store.state.oma_zip = value;
            }
        },
        oma_county: {
            get(){
                return this.$store.state.oma_county;
            },
            set(value){
                this.$store.state.oma_county = value;
            }
        },
        oma_primary_phone: {
            get(){
                return this.$store.state.oma_primary_phone;
            },
            set(value){
                this.$store.state.oma_primary_phone = value;
            }
        },
        oma_pri_phone_type: {
            get(){
                return this.$store.state.oma_pri_phone_type;
            },
            set(value){
                this.$store.state.oma_pri_phone_type = value;
            }
        },
        oma_secondary_phone: {
            get(){
                return this.$store.state.oma_secondary_phone;
            },
            set(value){
                this.$store.state.oma_secondary_phone = value;
            }
        },
        oma_sec_phone_type: {
            get(){
                return this.$store.state.oma_sec_phone_type;
            },
            set(value){
                this.$store.state.oma_sec_phone_type = value;
            }
        },
        oma_home_email: {
            get(){
                return this.$store.state.oma_home_email;
            },
            set(value){
                this.$store.state.oma_home_email = value;
            }
        },        
        oma_preferred_name:{
            get(){
                return this.$store.state.oma_preferred_name;
            },
            set(value){
                this.$store.state.oma_preferred_name = value;
            }
        },
        oma_previous_last_name:{
            get(){
                return this.$store.state.oma_previous_last_name;
            },
            set(value){
                this.$store.state.oma_previous_last_name = value;
            }
        },        
        oma_dob:{
            get(){
                return this.$store.state.oma_dob;
            },
            set(value){
                this.$store.state.oma_dob = value;
            }
        },
        oma_gender: {
            get(){
                return this.$store.state.oma_gender;
            },
            set(value){
                this.$store.state.oma_gender = value;
            }
        },
        oma_ethnicity: {
            get(){
                return this.$store.state.oma_ethnicity;
            },
            set(value){
                this.$store.state.oma_ethnicity = value;
            }
        },
        oma_pic_num: {
            get(){
                return this.$store.state.oma_pic_num;
            },
            set(value){
                this.$store.state.oma_pic_num = value;
            }
        },
        oma_pronouns: {
            get(){
                return this.$store.state.oma_pronouns;
            },
            set(value){
                this.$store.state.oma_pronouns = value;
            }
        },
        oma_pre_memb: {
            get(){
                return this.$store.state.oma_pre_memb;
            },
            set(value){
                this.$store.state.oma_pre_memb = value;
            }
        }
    },
    methods:{
        //place rules that reference other inputs here
        rules__oma_sec_phone_type(v){
            if(!this.oma_secondary_phone && !v){return true;}
            if(this.oma_secondary_phone && !v){return 'Secondary Phone Type is required';}
            if(!/^[A-z ]+$/.test(v)){return 'Secondary Phone Type is invalid'}
            return true;
        },    
        rules__oma_pri_phone_type(v){
            if(!this.oma_primary_phone && !v){return true;}
            if(this.oma_primary_phone && !v){return 'Primary Phone Type is required';}
            if(!/^[A-z ]+$/.test(v)){return 'Primary Phone Type is invalid'}
            return true;
        },
        rules__oma_confirm_home_email(v){            
            if(!v){return 'Please confirm your email';}
            if(this.oma_home_email.toLowerCase() != v.trim().toLowerCase()){return 'Must match home email address';}
            return true;
        },
        rules__oma_dob(v){
            if(!v){return 'Birthday is required';}
            const dob = new Date(v), 
                  today = new Date(), 
                  age = today.getYear() - dob.getYear();
            this.oma_dob = format(dob, 'P');
            if(age < 16 || age > 110){return 'Invalid Birthday';}            
            return true;
        },
        override_invalid_address: async function(){
            this.showSavingProgress = true;
            this.showInvalidAddressDialog = false;
            const override_payload = {doCmd:'mark_invalid_adr_bypass', app_id: window.sessionStorage.getItem('appID')};
            const override_invalid_address = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(override_payload), {
                headers : {'Content-Type': 'application/json'}
            });
            if(override_invalid_address.data.error > 0){
                this.showSavingProgress = false;
                this.showError = true;
                this.errorIsFatal = false;
                this.errorObj = {error: override_invalid_address.data.error, errortext: override_invalid_address.data.errortext};
                return;            
            }

            this.addressOverridden = true;
            this.validate_and_continue();
        },
        get_prefix_options: async function(){
            const namePrefix = {doCmd: 'get_name_prefix'};
            const get_name_prefix = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(namePrefix), {
                headers : {'Content-Type': 'application/json'}
            });
            if(get_name_prefix.data.error > 0){
                this.showError = true;
                this.errorObj = {error:get_name_prefix.data.error, errortext:get_name_prefix.data.errortext};
                this.errorIsFatal=false;                
                return;
            }

            this.prefix_options = Object.values(get_name_prefix.data.result);

            
        },
        get_suffix_options: async function(){
            const nameSuffix = {doCmd: 'get_name_suffix'};
            const get_name_suffix = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(nameSuffix), {
                headers : {'Content-Type': 'application/json'}
            });
            
            if(get_name_suffix.data.error > 0){
                this.showError = true;
                this.errorObj = {error:get_name_suffix.data.error, errortext:get_name_suffix.data.errortext};
                this.errorIsFatal=false;                
                return;
            }

            this.suffix_options = Object.values(get_name_suffix.data.result);
        },
        get_state_options: async function(){
            const get_states = await axios.get(`${this.$baseURL}/javascript/json/states.json`, '', {
                headers : {'Content-Type': 'application/json'}
            });

            Object.keys(get_states.data).forEach(s => {
                this.$store.state.stateOptions.push({abbr:s, val: get_states.data[s]});
            });
        },
        get_county_options: async function(){
             const countyPayload = {doCmd:'get_counties'};
            const get_counties = await axios.post(`${this.$baseURL}/common/mea_common/common_processor.php`, JSON.stringify(countyPayload), {
                headers : {'Content-Type': 'application/json'}
            });
            if(get_counties.data.error > 0){
                this.showError = true;
                this.errorObj = {error:get_counties.data.error, errortext:get_counties.data.errortext};
                this.errorIsFatal=false;
            }
            this.$store.state.countyOptions = get_counties.data.result;
        },
        get_gender_options: async function(){
            const genderPayload = {doCmd:'get_demo_option', demo_name:'oma_gender'};
            const get_genders = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(genderPayload), {
                headers : {'Content-Type': 'application/json'}
            });
            if(get_genders.data.error > 0){
                this.showError = true;
                this.errorObj = {error:get_genders.data.error, errortext:get_genders.data.errortext};
                this.errorIsFatal=false;                
                return;
            }
            this.gender_options = Object.values(get_genders.data.result);
        },
        get_ethnicity_options: async function(){
            const ethnicityPayload = {doCmd:'get_demo_option', demo_name:'oma_ethnicity'};
            const get_ethnicity = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(ethnicityPayload), {
                headers : {'Content-Type': 'application/json'}
            });

            if(get_ethnicity.data.error > 0){
                this.showError = true;
                this.errorObj = {error:get_ethnicity.data.error, errortext:get_ethnicity.data.errortext};
                this.errorIsFatal=false;                
                return;
            }

            this.ethnicity_options = Object.values(get_ethnicity.data.result);
        },
        get_pronoun_options: async function(){
            const pronounPayload = {doCmd:'get_demo_option', demo_name:'oma_pronouns'};
            const get_pronouns = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(pronounPayload), {
                headers : {'Content-Type': 'application/json'}
            });

            if(get_pronouns.data.error > 0){
                this.showError = true;
                this.errorObj = {error:get_pronouns.data.error, errortext:get_pronouns.data.errortext};
                this.errorIsFatal=false;                
                return;
            }

            this.pronoun_options = Object.values(get_pronouns.data.result);
        },
        async validate_and_continue(){
            if(!this.$refs.fm_personal_info.validate()){                
                this.showErrorsOnPage = true;                
                return false;
            }
            this.showSavingProgress = true;
            if(!this.$store.state.is_initiated){
                this.$store.state.initiate_pending = true;
                await this.$recaptchaLoaded();
                const token = await this.$recaptcha('validate_captcha');
                const iar = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify({doCmd:'initiate_app_record', app_id: window.sessionStorage.getItem('appID'), recaptcha: token}), {
                    headers : {'Content-Type': 'application/json'}
                });
                const {status, data: {error, errorref, result: {db_app_id}} } = iar;                
                if(status >= 500 ){              
                    this.showError = true;
                    const log = await this.log_activity('Unable to reach server for initiate app request', iar);
                    this.errorObj = {error: 1, errorref:log.data.errorref, errortext: 'An unexpected error occured initiating your app record. Please reload the page to continue.'};
                    this.errorIsFatal = true;            
                    return;
                }

                if(!db_app_id){
                    this.showError = true;
                    this.errorObj = {error: error, errortext: 'An unexpected error occured initiating your app record. Please reload the page to continue.', errorref: errorref};
                    this.errorIsFatal = true;
                    return;
                }
                
                this.$store.state.initiate_pending = false;
                this.$store.state.is_initiated = true;
            }

            
            if(!this.addressOverridden){
                this.log_activity('Attempting to validate address through LOB');
                const validate_addr_payload = {
                    userKey:'8wvqLx7Mri069UnN4Da0nGlKxDSRKVo5rT5', 
                    address_line1: this.oma_street_address1, 
                    address_line2: this.oma_street_address2, 
                    address_city:  this.oma_city,
                    address_state: this.oma_state,
                    address_zip:   this.oma_zip
                }
                const validate_addr = await axios.post(`${this.$baseURL}/utilities/api_helper/lob_address_verification.php`, JSON.stringify(validate_addr_payload), {
                    headers : {'Content-Type': 'application/json'}
                });
                const { data:{ error, errortext} } = validate_addr;
                if(error > 0){
                    return false;
                }
                
                const log_validation = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify({doCmd: 'log_adr_verification', app_id: window.sessionStorage.getItem('appID')}), {
                    headers : {'Content-Type': 'application/json'}
                });
                
                if(log_validation.data.error){
                    this.showError = true;
                    this.errorObj = {error:log_validation.data.error, errortext:log_validation.data.errortext};
                    this.errorIsFatal=false;
                }


                const log_validation_activity = await this.log_activity('lob address validation result', validate_addr.data);
                if(log_validation_activity.data.error){
                    window.sessionStorage.setItem('loggedLobResult', 0);
                }else{
                    window.sessionStorage.setItem('loggedLobResult', 1);
                }

                if(errortext == 'The address given is not a deliverable USPS address.'){
                    this.showSavingProgress = false;
                    this.showInvalidAddressDialog = true;
                    this.invalidAddressObject = {
                        oma_street_address1: this.oma_street_address1, 
                        oma_street_address2: this.oma_street_address2, 
                        oma_city:  this.oma_city,
                        oma_state: this.oma_state,
                        oma_zip:   this.oma_zip
                    };
                    return false;
                }
            }
            // get all the form data to update the db
            const formData = {
                doCmd: 'update_db',
                app_id: window.sessionStorage.getItem('appID'),
                oma_first_name:this.oma_first_name,
                oma_prefix:this.oma_prefix,
                oma_last_name:this.oma_last_name,
                oma_suffix:this.oma_suffix,
                oma_street_address1:this.oma_street_address1,
                oma_street_address2:this.oma_street_address2,
                oma_state:this.oma_state,
                oma_middle_name:this.oma_middle_name,
                oma_city:this.oma_city,
                oma_zip:this.oma_zip,
                oma_county:this.oma_county,
                oma_primary_phone:this.oma_primary_phone,
                oma_pri_phone_type:this.oma_pri_phone_type,
                oma_secondary_phone:this.oma_secondary_phone,
                oma_sec_phone_type:this.oma_sec_phone_type,
                oma_home_email:this.oma_home_email,
                oma_preferred_name:this.oma_preferred_name,
                oma_previous_last_name:this.oma_previous_last_name,
                oma_dob:this.oma_dob,
                oma_gender:this.oma_gender,
                oma_ethnicity:this.oma_ethnicity,
                oma_pic_num: this.oma_pic_num,
                oma_pronouns:this.oma_pronouns,
                oma_pre_memb:this.oma_pre_memb,          
                oma_ssn: this.oma_ssn
            }
            this.log_activity(`Attempting to update database with personal info`);

            const update_db = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(formData), {
                headers : {'Content-Type': 'application/json'}
            });

            if(update_db.data.result.has_error){
                this.showError = true;
                let errors = [];
                update_db.data.result.fail.forEach(v => errors.push(`REF# ${v.errorref} - ${v.errortext} <br/>`))
                this.errorObj = {errorref:false, errortext:errors.join('')};
                this.errorIsFatal = false;
                this.showSavingProgress = false;
                return;
            }

            if(update_db.data.error > 0){
                this.showError = true;
                this.errorObj = {errorref:update_db.data.errorref, errortext:update_db.data.errortext};
                this.errorIsFatal = false;
                this.showSavingProgress = false;
                return;
            }             

            const update_step_payload = {doCmd:'update_app_step', app_id: window.sessionStorage.getItem('appID'), number: 1 };
            const update_app_step = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(update_step_payload), {
                headers : {'Content-Type': 'application/json'}
            });
            const {data: {error:uas_error, errortext:uas_errortext}} = update_app_step;
            if(uas_error > 0){
                this.showError = true;
                this.errorObj = {error:uas_error, errortext:uas_errortext};
                this.errorIsFatal = false;
            }
            this.showSavingProgress = false;
            this.$emit('next-step');                        
        }       
    },
    mounted: async function(){
        this.get_prefix_options();
        this.get_suffix_options();
        this.get_state_options();
        this.get_gender_options();
        this.get_ethnicity_options();
        this.get_pronoun_options();
        this.get_county_options();        
    }  
  }
</script>
<style>
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button,
input[type='number'] {
  -webkit-appearance: none;
  margin: 0;
  -moz-appearance: textfield !important;
}

.hide-ssn input{
  -webkit-text-security:disc;
}

</style>
<style scoped>
.v-input--selection-controls.v-input--radio-group{
    margin-top:0px !important;
}


</style>